import { useWire } from "@core/wire";

export const useIsUserGettingStarted = () => {
  const wire = useWire();
  const [recentThreads] = wire.services.threads.threadsListResource;
  const [tree] = wire.services.collections.globalResourceTree;
  const isConnecting = wire.services.auth.isConnecting;

  const noCollections = () => {
    if (isConnecting()) return false;
    if (tree.loading) return false;

    // Checking this so that it doesn't trigger an error boundary
    if (!tree.loading && !tree.error) {
      // If any of the root collections have at least one collection inside, user is not getting started
      for (const col of tree.latest?.data || []) {
        if ((wire.services.collections.getChildrenIds(col.collection.id)?.length || 0) > 0) {
          return false;
        }
      }
    }

    return true;
  };

  const noThreads = () => {
    if (isConnecting()) return false;
    if (recentThreads.loading || tree.loading) return false;
    // If user has any threads, they're not just getting started
    if ((recentThreads.latest?.data.result.entities.length || 0) > 0) {
      return false;
    }
    return true;
  };
  const hasLessThanTwoThreads = () => {
    if (isConnecting()) return false;
    if (recentThreads.loading || tree.loading) return false;
    // If user has any threads, they're not just getting started
    if ((recentThreads.latest?.data.result.entities.length || 0) > 1) {
      return false;
    }
    return true;
  };

  return {
    isUserGettingStarted: () => noCollections() && hasLessThanTwoThreads(),
    noCollections,
    noThreads,
  };
};
